import "./auth.css"; // reuse the existing auth styling
import olympeakLogo from "../assets/olympeak_logo_new.png";

const authBg = "/images/olympeak_visual_1.png";

export default function PrivacyPolicy() {
  return (
    <div
      className="page-wrapper auth-bg"
      style={{ backgroundImage: `url(${authBg})` }}
    >
      <div className="page-container auth-container privacy-container">
        <div className="app-card auth-card privacy-card">
          <div className="auth-brand">
            <a href="/" className="auth-logo-link">
              <img
                src={olympeakLogo}
                alt="Olympeak"
                className="auth-brand-logo"
              />
            </a>
          </div>

          <div className="auth-form privacy-form">
            <div className="privacy-header">
              <h1 className="privacy-title">Privacy Policy</h1>
              <div className="privacy-updated">Last updated: 13 Dec 2025</div>
            </div>

            <div className="privacy-body">
              <p className="privacy-lead">
                This Privacy Policy explains how Olympeak (“we”, “us”) collects,
                uses, and shares information when you use our website and
                services.
              </p>

              <h2>1) Who we are</h2>
              <p>
                Olympeak is the controller of personal data processed through
                this website/app, unless stated otherwise.
              </p>

              <h2>2) What data we collect</h2>
              <ul>
                <li>
                  <b>Account data:</b> email, nickname (optional), password
                  (stored as a hash), and basic account metadata.
                </li>
                <li>
                  <b>Authentication data:</b> login events and session cookies.
                </li>
                <li>
                  <b>Usage & analytics data:</b> approximate usage data (e.g.,
                  page views) if you consent to analytics cookies.
                </li>
                <li>
                  <b>Support/contact data:</b> information you send us if you
                  contact support.
                </li>
              </ul>

              <h2>3) How we use your data</h2>
              <ul>
                <li>To provide and operate the service (login, account access).</li>
                <li>To secure the service and prevent abuse.</li>
                <li>
                  To improve the website/app (only where permitted and/or with
                  consent, e.g., analytics).
                </li>
                <li>To respond to support requests.</li>
              </ul>

              <h2>4) Legal bases (EEA/UK)</h2>
              <ul>
                <li>
                  <b>Contract:</b> to provide the service you request (account,
                  login).
                </li>
                <li>
                  <b>Legitimate interests:</b> security, fraud prevention,
                  service reliability.
                </li>
                <li>
                  <b>Consent:</b> analytics and non-essential cookies (you can
                  withdraw consent anytime via cookie settings).
                </li>
                <li>
                  <b>Legal obligation:</b> where we must comply with applicable
                  laws.
                </li>
              </ul>

              <h2>5) Cookies</h2>
              <p>
                We use cookies and similar technologies. Necessary cookies are
                used to keep you signed in and protect the service. Analytics
                cookies are used only if you consent.
              </p>
              <p className="hint">
                You can update your choices anytime via your cookie settings.
              </p>

              <h2>6) Sharing and processors</h2>
              <p>
                We may share data with trusted service providers (processors)
                that help us run the service (e.g., hosting, authentication,
                analytics—if enabled). They are bound by contractual obligations
                to protect your data.
              </p>

              <h2>7) International transfers</h2>
              <p>
                Some providers may process data outside your country. Where
                required, we use appropriate safeguards (such as standard
                contractual clauses).
              </p>

              <h2>8) Data retention</h2>
              <p>
                We keep personal data only as long as needed for the purposes
                described above, unless a longer retention period is required by
                law. You can request deletion of your account where applicable.
              </p>

              <h2>9) Your rights</h2>
              <ul>
                <li>Access, correction, deletion</li>
                <li>Objection and restriction</li>
                <li>Data portability</li>
                <li>Withdraw consent (where processing is based on consent)</li>
                <li>Complain to a supervisory authority</li>
              </ul>

              <h2>10) Security</h2>
              <p>
                We use reasonable technical and organizational measures to
                protect your information. No method of transmission or storage
                is 100% secure.
              </p>

              <h2>11) Children</h2>
              <p>
                Our service is not intended for children. If you believe a child
                provided personal data, contact us to remove it.
              </p>

              <h2>12) Contact</h2>
              <p>
                If you have questions or requests, contact us at:{" "}
                <a className="app-link" href="mailto:privacy@olympeak.app">
                  privacy@olympeak.app
                </a>
              </p>
            </div>

            <div className="privacy-footer">
              <a className="btn" href="/">
                Back to home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}